'use strict';

function parse(reader) {
    reader.readUInt8('data.params.pin_index');
    reader.readBit(2, 'data.params.pin_status');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/input-status-parser.js